<template>
  <div>
    <div class="desktop">
      <div class="reload">
        Обновите страницу
      </div>
    </div>
    <div class="fulfillment">
      <router-link to="/fulfillment">
        <img
          class="logo-text"
          src="../assets/greysislogotext.svg"
          alt="Greysis Logo Text"
        />
      </router-link>
      <menu-icon></menu-icon>

      <div class="topImg"></div>

      <wrap
        title="О нас"
        pTag="Greysis - Разрабатывает интеллектуальные системы будущего цифровой экономики Узбекистана"
      ></wrap>

      <div class="go-down"></div>

      <div class="voice">
        <div class="play-button"></div>
        <div id="waveform">
          <div class="wave-cover"></div>
        </div>
      </div>

      <div class="informationAbout">
        <h2>Что такое Greysis</h2>
        <p>Greysis разрабатывает комплекс интеллектуальных систем будущего цифровой экономики. 
Внедрив решения Greysis вы открывете новые возможности 
в электронной коммерции.</p>
        <div class="infoImgOne infoImg"></div>
      </div>

      <div class="informationAbout">
        <h2>Зачем нужен</h2>
        <p>Разработки Greysis позволят внедрить контроль и аналитику над всеми бизнес-процессами компании. Полученные интеллектуальными системами данные кардинально изменят прибыль вашей компании.</p>
        <div class="infoImgTwo infoImg"></div>
      </div>

      <div class="informationAbout">
        <h2>Как стать частью</h2>
        <p>Импортёры, производители, крупные поставщики, со всех уголков страны планирующие выйти на глобальный рынок электронной коммерции обратившись в Greysis получают доступ к интеллектуальным системам будущего цифровой экономики</p>
        <div class="infoImgThree infoImg"></div>
      </div>

      <div class="morePages">
        <h1 class="info">
          Вам так же будет <br />
          интересно:
        </h1>
        <div class="more-cover">
          <div class="more-info">
            <div class="more-item more-item2">
              <div class="more-decr">
                <h1>Fullfilment</h1>
                <div class="cover"></div>
                <h6>Обработка заказов интернет-магазинов</h6>
              </div>
              <router-link to="/fulfillment"
                ><div class="angle enter">Перейти</div></router-link
              >
            </div>
            <div class="more-item more-item3">
              <div class="more-decr">
                <h1>Call-Centre</h1>
                <div class="cover"></div>
                <h6>
                  Обработка заказов интернет- магазинов
                </h6>
              </div>
              <router-link to="/callcenter"
                ><div class="angle enter">Перейти</div></router-link
              >
            </div>
            <div class="more-item more-item4">
              <div class="more-decr">
                <h1>Консалтинг</h1>
                <div class="cover"></div>
                <h6>
                  На любой ваш вопрос в электронной коммерции у нас уже есть
                  ответы
                </h6>
              </div>
              <router-link to="/consulting"
                ><div class="angle enter">Перейти</div></router-link
              >
            </div>
            <div class="more-item more-item4">
              <div class="more-decr">
                <h1>Инвесторам</h1>
                <div class="cover"></div>
                <h6>
                  Вы крупный поставщик или импортёр продукции широкого спроса, который хочет продавать онлайн?
                </h6>
              </div>
              <router-link to="/invest"
                ><div class="angle enter">Перейти</div></router-link
              >
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <h1 class="info contact-title" id="see-grey">
          Обратиться в <br />
          Greysis:
        </h1>

        <router-link to="/contactmobile">
          <div class="angle enter contact-mobile">Контакты</div>
        </router-link>
      </div>

      <music class="ms"></music>
      <footerWrap></footerWrap>
    </div>
  </div>
</template>

<script>
import { TimelineMax, gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
import $ from "jquery";
import WaveSurfer from "wavesurfer.js";

import music from "../components/audio.vue";
import menuIcon from "../components/menuMobile.vue";
import wrap from "../components/wrapper.vue";
import footerWrap from "../components/footer.vue";

export default {
  name: "aboutMobile",
  components: {
    music,
    menuIcon,
    footerWrap,
    wrap,
  },
  data () {
    return {
      isMusic: null
    }
  },
  methods: {
    hey: function() {
      var load = this

      var myAudio = document.getElementById('audio');

      if (myAudio.paused) 
      {
        this.isMusic = false
      } else {
        this.isMusic = true
      }

      $('.audio').click(function(){
        if (myAudio.paused) 
        {
          load.isMusic = false
        } else {
          load.isMusic = true
        }
      }) 

      var wavesurfer = WaveSurfer.create({
          container: '#waveform',
          barWidth: 3,
          barHeight: 0.5,
          barGap: 5,
          waveColor: 'rgba(244,255,255,0.3)',
          progressColor: 'white',
          cursorWidth: 0
      });
      wavesurfer.load('about.mp3');
      wavesurfer.setVolume(0.15);

      $('#menu #menu-cover ul li').click(function() {
        wavesurfer.destroy()
      })

      $('.more-item').click(function() {
        wavesurfer.destroy()
      })

      $('.contact-mobile').click(function() {
        wavesurfer.destroy()
      })

      $(".play-button").on('click', function () {
        if(!wavesurfer.isPlaying())
        {
          wavesurfer.play();
          myAudio.pause();
          $(".play-button").css('background-image', "url(" + require("../assets/pause.svg") + ")")
        }
        else
        {
          if (load.isMusic)
          {
            myAudio.play();
            myAudio.volume = 0.05;
          }
          else
          {
            myAudio.pause();
          }
          wavesurfer.pause();
          $(".play-button").css('background-image', "url(" + require("../assets/play.svg") + ")")
        }
      });

      gsap.registerPlugin(CSSPlugin);
      $("html, body").animate({ scrollTop: 0 }, "slow");

      var cover = new TimelineMax();

      cover.set(".wrapper", { overflow: "hidden" });
      cover.set(".cover", { width: "0%" });
      cover.set(".title", { alpha: 0 });
      cover.set(".wrapper p", { translateY: "100vh" });
      cover.set(".voice", { translateY: "100vh" });
      cover.to(".cover", 1, { delay: 1, width: "100%" });
      cover.to(".title", 0.1, { alpha: 1 });
      cover.to(".cover", 1, { width: "10px", right: "unset", left: 0 });
      cover.to(".wrapper p, .voice", 1, { translateY: "6%" });
      cover.set(".wrapper", { overflow: "visible" });
      var width = new TimelineMax();
      width.to(".timer", 4, { delay: 1, width: "50vw" });
      width.to(".timer", 0.5, { opacity: 0 });

      $(".go-down").click(function() {
        $("html, body").animate({ scrollTop: window.innerHeight }, "slow");
      });
    },
  },
  mounted() {
    if (this.$route.name == "about") {
      this.hey();
    }
  },
};
</script>

<style scoped>
.desktop {
  display: block;
}

.fulfillment {
  display: none;
}
.reload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.reload a {
  text-decoration: underline;
  opacity: 0.7;
}

.go-down
{
  display: none;
}

@media only screen and (max-width: 900px) {
  .go-down {
    width: 40px;
    height: 40px;
    background-image: url("../assets/arrow.svg");
    background-size: contain;
    transform: rotate(-90deg);
    margin: 20px auto;
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) rotate(-90deg);
    bottom: 10px;
    z-index: 20;
  }

  .ms
  {
    z-index: 10;
  }

  .informationAbout
  {
    width: 80%;
    margin-left: 10vw;
    margin-top: 50px;
  }

  .informationAbout p
  {
    margin-top: 20px;
  }

  .infoImg
  {
    margin-top: 20px;
    height: 200px;
    width: 125%;
    background-position: center;
    background-size: cover;
    margin-left: -10vw;
  }

  .infoImgOne
  {
    background-image: url("../assets/about1.png");
  }

  .infoImgTwo
  {
    background-image: url("../assets/about2.png");
  }

  .infoImgThree
  {
    background-image: url("../assets/about3.png");
  }

  .wave-cover
  {
    width: calc(100% + 1px);
    height: 64px;
    position: absolute;
    background-color: #1e1e1e;
    z-index: 10;
    bottom: 0;
    right: 0;
  }

  #waveform
  {
    width: 80%;
    position: absolute;
    right: 0;
    display: inline-block;
  }

  .play-button
  {
    width: 20%;
    height: 30px;
    display: inline-block;
    background-image: url("../assets/play.svg");
    background-size: contain;
    background-position: left center;
    background-repeat: no-repeat;
    position: relative;
    top: 40px;
  }

  .voice
  {
    position: absolute;
    top: 70%;
    left: 30px;
    /* transform: translateX(-50%); */
    width: 80%;
    height: 100px;
    z-index: 10;
  }

  .contact {
    width: 80vw;
    margin-left: 10vw;
    margin-bottom: 50px;
  }

  .contact-title {
    margin-bottom: 30px;
  }

  .contact .angle {
    margin-left: 20px;
  }

  .cover {
    height: 30px;
    position: absolute;
    background-color: #2778f3;
    top: 0;
    right: 0;
  }
  .more-item {
    margin-bottom: 50px;
  }

  .angle {
    font-size: calc(1vw + 0.9vh + 0.6vmin);
    width: 50%;
    background-color: #2778f3;
    margin-top: 10px;
    padding: 7.5px;
  }

  .more-decr h1 {
    font-size: 1.4rem;
    margin-left: 20px;
  }

  .more-decr h6 {
    margin-top: 10px;
    font-weight: 100;
    font-size: 0.9em;
    padding-right: 20px;
    line-height: 23px;
    margin-left: 20px;
  }

  .more-cover {
    height: 100%;
    margin-top: 50px;
  }

  .more-info {
    display: grid;
    grid-template-columns: 1fr;
  }

  .more-info .angle {
    margin-left: 20px;
  }

  .more-info .more-item {
    position: relative;
  }

  .morePages {
    margin-top: 50px;
    margin-left: 10vw;
    width: 80%;
  }

  .fulfillment {
    display: block;
  }

  .desktop {
    display: none;
  }

  .info {
    font-size: 1.6rem;
    font-weight: 100;
  }

  .topImg {
    height: 50vh;
    width: 100vw;
    background-image: url("../assets/mobileAbout.gif");
    background-position: center;
    background-size: 70%;
    background-repeat: no-repeat;
  }

  .logo-text {
    width: 30vw;
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .nav {
    position: absolute;
    left: 20vw;
    top: 30px;
    display: none;
  }

  .nav li {
    font-size: calc(0.6vw + 0.5vh + 0.5vmin);
    display: inline-block;
    padding: 0 15px;
    color: #dedede;
    cursor: pointer;
    transition: 0.3s;
  }

  .nav li:hover {
    color: white;
  }

  .contacts {
    padding: 0 30px 5px 30px !important;
    margin-left: 20px;
    border-bottom: 2px solid #2778f3;
    text-transform: capitalize;
  }

  #container {
    position: absolute;
    top: 0;
    overflow: hidden;
    outline: 0;
  }

  canvas:focus,
  #container:focus {
    outline: 0;
  }

  @keyframes alpha {
    0% {
      opacity: 0;
    }

    90% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}
</style>
